import { SupportDeviceModel } from "./support-device-model";

export type ProductImage = { [key in SupportDeviceModel | string]: string }